import { DecimalPipe, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'app/Shared/Services/user.service';
import { ScrollPanelModule } from 'primeng/scrollpanel';

@Component({
  selector: 'app-stat-box',
  imports: [NgClass, ScrollPanelModule,DecimalPipe],
  templateUrl: './stat-box.component.html',
  styleUrl: './stat-box.component.scss',
})
export class StatBoxComponent implements OnInit {
@Input('defaultFilters') DefaultFilterArray: any = [];
@Input() orderCategary: any;
@Input() RouteCategary: any;
@Input()displayDivider!:boolean;

constructor( private userService: UserService,
    private router: Router) { }

  ngOnInit(): void {
  }

   openTransactionScreen(type: any, item: any) {
    let filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    let fromDate =  this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    let toDate =  this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    let trasactionType = type;
    let value = item;
    
    if(value == ""){
      const url = this.router.serializeUrl(this.router.createUrlTree(['Rsms/pages/Reg-Reporting/Order-Details'],
        {
          queryParams : {
            fromDate: fromDate,
            toDate: toDate,
            transactionType:trasactionType,
          }
        }
      ));
      window.open('#' + url, '_blank');
    }
    else{
     const url = this.router.serializeUrl(this.router.createUrlTree(['Rsms/pages/Reg-Reporting/Order-Details'],
        {
          queryParams : {
            fromDate: fromDate,
            toDate: toDate,
            transactionType:trasactionType,
            value: value
          }
        }
      ));
      window.open('#' + url, '_blank');
    }
  }


  getPercentage(numerator: number, denominator: number) {
    if (!denominator || denominator === 0) {
      return 0;
    }
    const percentage = (numerator / denominator) * 100;

    if (percentage === 0) {
      return '';
    }
    return Number.isInteger(percentage)
      ? percentage
      : percentage.toFixed(2);
  }

  get orderCategoryItems() {
    return [
      { label: 'Total', screenKey: '', boxClass: 'greenBox', count: this.orderCategary?.totalOrders, shares: this.orderCategary?.totalShares, showPercentage: false },
      { label: 'Reportable', screenKey: 'isReportableSymbol', boxClass: 'blueBox', count: this.orderCategary?.reportableOrders, shares: this.orderCategary?.reportableShares, showPercentage: false },
      { label: 'Equities', screenKey: 'equitiesOrder', boxClass: 'blueBox', count: this.orderCategary?.equitiesOrder, shares: this.orderCategary?.equitiesShares, showPercentage: true },
      { label: 'S&P 500', screenKey: 'SNP500', boxClass: 'blueBox', count: this.orderCategary?.snp500Orders, shares: this.orderCategary?.snp500Shares, showPercentage: true },
      { label: 'Held', screenKey: 'held', boxClass: 'blueBox', count: this.orderCategary?.heldOrder, shares: this.orderCategary?.heldShares, showPercentage: true },
      { label: 'Options', screenKey: 'OptionsOrder', boxClass: 'blueBox', count: this.orderCategary?.OptionsOrder, shares: this.orderCategary?.OptionsShares, showPercentage: true },
      { label: 'Non-Directed', screenKey: 'nonDirected', boxClass: 'blueBox', count: this.orderCategary?.nonDirectedOrder, shares: this.orderCategary?.nonDirectedShares, showPercentage: true },
      { label: 'Equities Non-Dir', screenKey: 'equitiesNonDirectedOrder', boxClass: 'blueBox', count: this.orderCategary?.equitiesNonDirectedOrder, shares: this.orderCategary?.equitiesNonDirectedShares, showPercentage: true },
      { label: 'Options Non-Dir', screenKey: 'optionsNonDirectedOrder', boxClass: 'blueBox', count: this.orderCategary?.optionsNonDirectedOrder, shares: this.orderCategary?.optionsNonDirectedShares, showPercentage: true }
    ];
  }

  get routeCategoryItems() {
    return [
      { label: 'Total', screenKey: '', boxClass: 'greenBox', count: this.RouteCategary?.totalRoutes, percentageBasis: null },
      { label: 'Reportable', screenKey: 'isReportableSymbol', boxClass: 'blueBox', count: this.RouteCategary?.reportableRoutes, percentageBasis: null },
      { label: 'Held', screenKey: 'held', boxClass: 'blueBox', count: this.RouteCategary?.heldRoutes, percentageBasis: this.RouteCategary?.reportableRoutes },
      { label: 'Non-Directed', screenKey: 'nonDirected', boxClass: 'blueBox', count: this.RouteCategary?.nonDirectedRoutes, percentageBasis: this.RouteCategary?.heldRoutes }
    ];
  }

  get subRouteSections() {
    return [
      {
        title: 'Equities',
        screenKey: 'equitiesRoutes',
        count: this.RouteCategary?.nonDirectedEquitiesRoutes,
        percentageBasis: this.RouteCategary?.allEquitiesRoutes,
        items: [
          { label: 'Market', screenKey: 'equitiesMarket', count: this.RouteCategary?.equitiesMarket, percentageBasis: this.RouteCategary?.nonDirectedEquitiesRoutes },
          { label: 'Marketable Limit', screenKey: 'equitiesMarketableLimit', count: this.RouteCategary?.equitiesMarketableLimit, percentageBasis: this.RouteCategary?.nonDirectedEquitiesRoutes },
          { label: 'Non-Marketable Limit', screenKey: 'equitiesNonMarketableLimit', count: this.RouteCategary?.equitiesNonMarketableLimit, percentageBasis: this.RouteCategary?.nonDirectedEquitiesRoutes },
          { label: 'Other', screenKey: 'equitiesOther', count: this.RouteCategary?.equitiesOther, percentageBasis: this.RouteCategary?.nonDirectedEquitiesRoutes }
        ]
      },
      {
        title: 'S&P 500',
        screenKey: 'snp500Routes',
        count: this.RouteCategary?.nonDirectedSnp500Routes,
        percentageBasis: this.RouteCategary?.allSnp500Routes,
        items: [
          { label: 'Market', screenKey: 'SNP500Market', count: this.RouteCategary?.SNP500Market, percentageBasis: this.RouteCategary?.nonDirectedSnp500Routes },
          { label: 'Marketable Limit', screenKey: 'SNP500MarketableLimit', count: this.RouteCategary?.SNP500MarketableLimit, percentageBasis: this.RouteCategary?.nonDirectedSnp500Routes },
          { label: 'Non-Marketable Limit', screenKey: 'SNP500NonMarketableLimit', count: this.RouteCategary?.SNP500NonMarketableLimit, percentageBasis: this.RouteCategary?.nonDirectedSnp500Routes },
          { label: 'Other', screenKey: 'SNP500Other', count: this.RouteCategary?.SNP500Other, percentageBasis: this.RouteCategary?.nonDirectedSnp500Routes }

        ]
      },
      {
        title: 'Options',
        screenKey: 'OptionsRoute',
        count: this.RouteCategary?.nonDirectedOptionsRoute,
        percentageBasis: this.RouteCategary?.allOptionsRoute,
        items: [
          { label: 'Market', screenKey: 'optionsMarket', count: this.RouteCategary?.optionsMarket, percentageBasis: this.RouteCategary?.nonDirectedOptionsRoute },
          { label: 'Marketable Limit', screenKey: 'optionsMarketableLimit', count: this.RouteCategary?.optionsMarketableLimit, percentageBasis: this.RouteCategary?.nonDirectedOptionsRoute },
          { label: 'Non-Marketable Limit', screenKey: 'optionsNonMarketableLimit', count: this.RouteCategary?.optionsNonMarketableLimit, percentageBasis: this.RouteCategary?.nonDirectedOptionsRoute },
          { label: 'Other', screenKey: 'optionsOther', count: this.RouteCategary?.optionsOther, percentageBasis: this.RouteCategary?.nonDirectedOptionsRoute }

        ]
      }
    ];
  }

}
